import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import { VIEW_PROFILE } from "../../query/ViewProfile";
import { VIEW_ROLE } from "../../query/ViewRole";

const BusinessHeader = () => {
  const { data: userRole } = useQuery(VIEW_ROLE, {
    variables: {
      userId: localStorage.getItem("user_id"),
    },
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });

  const { data } = useQuery(VIEW_PROFILE, {
    fetchPolicy: "cache-and-network",
    client: hasuraClient,
  });

  return userRole?.users[0].role === "business" ? (
    <div className="council-header">
      <div className="council-edit">
        <Link to="/edit-business-profile">
          <button>Edit Profile</button>
        </Link>
      </div>
      <div className="council-header-row">
        <div className="council-header-inner">
          <div className="user-photo">
            {data?.users[0]?.business_profile?.business_profile_photo && (
              <img
                src={data?.users[0]?.business_profile?.business_profile_photo}
                alt="user"
              />
            )}
          </div>
          <div class="council-header-right">
            <div class="user-name">
              <h1>
                {data &&
                data?.users[0] &&
                data?.users[0]?.business_profile?.name
                  ? data?.users[0]?.business_profile?.name
                  : ""}
              </h1>

              {data?.users[0]?.business_profile?.website ? (
                <Link
                  to={{ pathname: data?.users[0]?.business_profile?.website }}
                  target="_blank"
                >
                  Website
                </Link>
              ) : (
                <a href="javascript:void(0)">Website</a>
              )}
            </div>
            <div>
              <ul class="user-info">
                <li>
                  <label>LOCATION</label>
                  <p>
                    {data &&
                    data?.users[0] &&
                    data?.users[0]?.business_profile?.location_text
                      ? data?.users[0]?.business_profile?.location_text
                      : ""}
                  </p>
                </li>
                <li>
                  <label>EMAIL</label>
                  <p>
                    {data && data?.users[0] && data?.users[0]?.email
                      ? data?.users[0]?.email
                      : data && data?.users[0] && data?.users[0]?.email
                      ? data?.users[0]?.email
                      : " - "}
                  </p>
                </li>
                <li>
                  <label>Phone</label>
                  <p>
                    {data &&
                    data?.users[0] &&
                    data?.users[0]?.business_profile?.mobile_number ? (
                      <a
                        href={`tel:${data?.users[0]?.business_profile?.mobile_number}`}
                        style={{ color: "#161f3d" }}
                      >
                        {data?.users[0]?.business_profile?.mobile_number}
                      </a>
                    ) : (
                      " - "
                    )}
                  </p>
                </li>
                {/* <li>
                <label>OPENING HOURS</label>

                {data
                  ? typeof data?.users[0]?.business_profile?.opening_hours ===
                    "object"
                    ? data?.users[0]?.business_profile?.opening_hours?.map(
                        (day) => {
                          return (
                            <p
                              style={{
                                fontSize: 14,
                                fontWeight: 400,
                                marginBottom: 10,
                              }}
                            >
                              {" "}
                              {day.dayName}:{" "}
                              {day?.close === null ||
                              day?.close === "" ||
                              day?.open === null ||
                              day?.open === "" ? (
                                "Closed"
                              ) : (
                                <>
                                  {day.open
                                    ? moment(day.open, "hh:mm").format(
                                        "hh:mm A"
                                      )
                                    : null}{" "}
                                  -{" "}
                                  {day.close
                                    ? moment(day.close, "hh:mm").format(
                                        "hh:mm A"
                                      )
                                    : null}{" "}
                                </>
                              )}
                            </p>
                          );
                        }
                      )
                    : JSON?.parse(
                        data?.users[0]?.business_profile?.opening_hours
                      ).map((day) => {
                        return (
                          <p
                            style={{
                              fontSize: 14,
                              fontWeight: 400,
                              marginBottom: 10,
                            }}
                          >
                            {" "}
                            {day.dayName}:{" "}
                            {day?.close === null ||
                            day?.close === "" ||
                            day?.open === null ||
                            day?.open === "" ? (
                              "Closed"
                            ) : (
                              <>
                                {day.open
                                  ? moment(day.open, "hh:mm").format("hh:mm A")
                                  : null}{" "}
                                -{" "}
                                {day.close
                                  ? moment(day.close, "hh:mm").format("hh:mm A")
                                  : null}{" "}
                              </>
                            )}
                          </p>
                        );
                      })
                  : null}
              </li> */}
              </ul>
            </div>
          </div>
        </div>
        <div style={{ padding: "0px 30px 30px", backgroundColor: "#fff" }}>
          <label
            style={{
              fontSize: "12px",
              lineHeight: "14px",
              fontWeight: "600",
              marginBottom: "7px",
              color: "#696ae7",
              textTransform: "uppercase",
            }}
          >
            Description
          </label>
          <p
            style={{
              maxHeight: "37px",
              overflowX: "hidden",
              overflowY: "auto",
              fontSize: "14px",
              lineHeight: "17px",
              marginBottom: "0px",
            }}
          >
            {data &&
            data?.users[0] &&
            data?.users[0]?.business_profile?.description
              ? data?.users[0]?.business_profile?.description
              : " - "}
          </p>
        </div>
      </div>
    </div>
  ) : (
    <div className="council-header">
      <div className="council-edit">
        <Link to="/edit-club-profile">
          <button>Edit Profile</button>
        </Link>
      </div>
      <div className="council-header-row">
        <div className="council-header-inner">
          <div className="user-photo">
            {data?.users[0]?.club_profile?.profile_photo && (
              <img
                src={data?.users[0]?.club_profile?.profile_photo}
                alt="user"
              />
            )}
          </div>
          <div class="council-header-right">
            <div class="user-name">
              <h1>
                {data && data?.users[0] && data?.users[0]?.club_profile?.name
                  ? data?.users[0]?.club_profile?.name
                  : ""}
              </h1>

              {data?.users[0]?.club_profile?.website ? (
                <Link
                  to={{ pathname: data?.users[0]?.club_profile?.website }}
                  target="_blank"
                >
                  Website
                </Link>
              ) : (
                <a href="javascript:void(0)">Website</a>
              )}
            </div>
            <ul class="user-info">
              <li>
                <label>LOCATION</label>
                <p>
                  {data &&
                  data?.users[0] &&
                  data?.users[0]?.club_profile?.location_text
                    ? data?.users[0]?.club_profile?.location_text
                    : ""}
                </p>
              </li>
              <li>
                <label>EMAIL</label>
                <p>
                  {data && data?.users[0] && data?.users[0]?.email
                    ? data?.users[0]?.email
                    : data && data?.users[0] && data?.users[0]?.email
                    ? data?.users[0]?.email
                    : " - "}
                </p>
              </li>
              <li>
                <label>Phone</label>
                <p>
                  {data &&
                  data?.users[0] &&
                  data?.users[0]?.club_profile?.mobile_number
                    ? data?.users[0]?.club_profile?.mobile_number
                    : " - "}
                </p>
              </li>
              {/* <li>
              <label>OPENING HOURS</label>

              {data
                ? typeof data?.users[0]?.business_profile?.opening_hours ===
                  "object"
                  ? data?.users[0]?.business_profile?.opening_hours?.map(
                      (day) => {
                        return (
                          <p
                            style={{
                              fontSize: 14,
                              fontWeight: 400,
                              marginBottom: 10,
                            }}
                          >
                            {" "}
                            {day.dayName}:{" "}
                            {day?.close === null ||
                            day?.close === "" ||
                            day?.open === null ||
                            day?.open === "" ? (
                              "Closed"
                            ) : (
                              <>
                                {day.open
                                  ? moment(day.open, "hh:mm").format(
                                      "hh:mm A"
                                    )
                                  : null}{" "}
                                -{" "}
                                {day.close
                                  ? moment(day.close, "hh:mm").format(
                                      "hh:mm A"
                                    )
                                  : null}{" "}
                              </>
                            )}
                          </p>
                        );
                      }
                    )
                  : JSON?.parse(
                      data?.users[0]?.business_profile?.opening_hours
                    ).map((day) => {
                      return (
                        <p
                          style={{
                            fontSize: 14,
                            fontWeight: 400,
                            marginBottom: 10,
                          }}
                        >
                          {" "}
                          {day.dayName}:{" "}
                          {day?.close === null ||
                          day?.close === "" ||
                          day?.open === null ||
                          day?.open === "" ? (
                            "Closed"
                          ) : (
                            <>
                              {day.open
                                ? moment(day.open, "hh:mm").format("hh:mm A")
                                : null}{" "}
                              -{" "}
                              {day.close
                                ? moment(day.close, "hh:mm").format("hh:mm A")
                                : null}{" "}
                            </>
                          )}
                        </p>
                      );
                    })
                : null}
            </li> */}
            </ul>
          </div>
        </div>
        <div style={{ padding: "0px 30px 30px", backgroundColor: "#fff" }}>
          <label
            style={{
              fontSize: "12px",
              lineHeight: "14px",
              fontWeight: "600",
              marginBottom: "7px",
              color: "#696ae7",
              textTransform: "uppercase",
            }}
          >
            Description
          </label>
          <p
            style={{
              maxHeight: "37px",
              overflowX: "hidden",
              overflowY: "auto",
              fontSize: "14px",
              lineHeight: "17px",
              marginBottom: "0px",
            }}
          >
            {data && data?.users[0] && data?.users[0]?.club_profile?.description
              ? data?.users[0]?.club_profile?.description
              : " - "}
          </p>
        </div>
      </div>
    </div>
  );
};

export default BusinessHeader;
